import { createSlice } from '@reduxjs/toolkit'
import { fetchFeedbackTypes } from '../thunks/support'

export const supportSlice = createSlice({
  name: 'support',
  initialState: {
    feedbackTypes: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchFeedbackTypes.fulfilled, (state, { payload }) => {
      state.feedbackTypes = payload?.data || []
    })
  },
})

// Action creators are generated for each case reducer function
// export const {  } = supportSlice.actions

export const supportSelector = (state) => state.support
export const supportReducer = supportSlice.reducer
